import { Component, EventBus } from '../core/smpl-components.js'
import { Events } from '../core/events.js'
import { MediaSwitch } from '../utils/media-switch.js'
import { MqlMatchMedia } from '../utils/mql-match-media.js'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
import ArrowAnimation from '../animations/dde_arrow_animation.json'
import HeaderAnimationLandscape from '../animations/dde_header_landscape.json'
import HeaderAnimationPortrait from '../animations/dde_header_portrait.json'
import lottie from 'lottie-web'

gsap.registerPlugin(ScrollToPlugin)

// -- Header Arrow ------------------------------------------------- //
class HeaderArrow {
	constructor(el) {
		this.el = el
		this.elFigure = this.el.querySelector('figure')

		this.bndOnClick = this.onClick.bind(this)
		this.el.addEventListener('click', this.bndOnClick)

		this.arrowAnimation = lottie.loadAnimation({
			container: this.elFigure, // the dom element that will contain the animation
			renderer: 'svg',
			loop: true,
			autoplay: true,
			animationData: ArrowAnimation,
		})

		this.setupArrowAnimation()
	}
	setupArrowAnimation() {}
	onClick() {
		this.scrollDown()
	}
	scrollDown() {
		gsap.to(window, {
			duration: 0.8,
			scrollTo: window.innerHeight,
			ease: 'power4.out',
		})
	}
	destroy() {
		this.el.removeEventListener('click', this.bndOnClick)
		this.arrowAnimation.destroy()
	}
}

// -- Logo Animation ------------------------------------------------- //
class LogoAnimation {
	constructor(el) {
		this.el = el
		this.elFigure = this.el.querySelector('.page-hero__logo figure')

		// matchMedia rather than the orientationchange event: that event never
		// fires when a desktop window is reshaped, so the landscape animation
		// would stay loaded in a portrait-shaped window. MqlMatchMedia calls back
		// synchronously on construction, which does the initial setup() for us.
		this.bndOnOrientationChange = this.onOrientationChange.bind(this)
		this.mql = new MqlMatchMedia('(orientation: portrait)', this.bndOnOrientationChange)
	}
	setup(isPortrait) {
		this.destroyAnimation()

		const animationData = isPortrait ? HeaderAnimationPortrait : HeaderAnimationLandscape

		this.logoAnimation = lottie.loadAnimation({
			container: this.elFigure, // the dom element that will contain the animation
			renderer: 'svg',
			loop: false,
			autoplay: false,
			animationData,
		})

		this.playTimeout = setTimeout(() => {
			this.playTimeout = null
			this.logoAnimation?.play()
		}, 250)
	}
	onOrientationChange(isPortrait) {
		this.setup(isPortrait)
	}
	destroyAnimation() {
		// A pending play() would fire against a destroyed animation when the
		// orientation flips again within the delay.
		if (this.playTimeout) {
			clearTimeout(this.playTimeout)
			this.playTimeout = null
		}

		if (this.logoAnimation) {
			this.logoAnimation.destroy()
			this.logoAnimation = null
		}
	}
	destroy() {
		if (this.mql) {
			this.mql.destroy()
			this.mql = null
		}
		this.destroyAnimation()
	}
}

// -------------------------------------------------------------------------- //
export default class extends Component {
	prepare() {
		this.elArrowButton = this.element.querySelector('.js-arrow-button')
		if (this.elArrowButton) {
			this.headerArrow = new HeaderArrow(this.elArrowButton)
		}

		const elMediaSwitch = this.element.querySelector('[data-media-switch]')
		if (elMediaSwitch) {
			this.mediaSwitch = new MediaSwitch(elMediaSwitch)
		}

		if (this.element.classList.contains('page-hero--logo')) {
			this.logoAnimation = new LogoAnimation(this.element)
		}
	}
	mount() {
		// console.log(window.lenis)
		// this.headerColor = new HeaderColor(this.element, {})
	}
	unmount() {
		if (this.mediaSwitch) {
			this.mediaSwitch.destroy()
		}

		if (this.headerArrow) {
			this.headerArrow.destroy()
		}

		if (this.logoAnimation) {
			this.logoAnimation.destroy()
		}
	}
}
